import { useState } from 'react';
import classNames from 'classnames/bind';

import ChartTimeFilters from '../../../ChartFilters/ChartTimeFilters';

import {
  capitalStructureChartFilter,
} from '../../../../../data/directory/topics/capitalStructure';

import CapitalCharts from './CapitalCharts';
import Tooltip from '../../../../Tooltip';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

const ChartBox = (props) => {
  const {
    title, chartType, companyNumber, firstChartData,
  } = props;
  const [activeFilter, setActiveFilter] = useState('All');

  const setTimeFilter = (value) => {
    setActiveFilter(value);
  };

  return (
    <div className={cx('chart-box', chartType)}>
      <div className={Styles['chart-box-header']}>
        <div className={Styles['chart-box-header-inner']}>
          <div className={Styles['chart-box-header-title']}>
            {title}
          </div>
          <Tooltip
            newIcon
            hasBigScreenDesign
            isCentered
            className={Styles['chart-box-header-tooltip']}
          >
            {chartType === 'marketCap' ? (
              <>
                Timeseries of the valuation based on price per share and number of shares,
                adjusted for splits and may include option exercises,
                which may have lower strike prices than market.
              </>
            ) : (
              <>
                Timeseries of the price per share based on filings,
                adjusted for splits and may include options exercises,
                which may have lower strike prices than market.
              </>
            )}
          </Tooltip>
        </div>
        <div className={Styles['chart-box-filter']}>
          <div className={Styles['chart-box-filter-title']}>Period:</div>
          <ChartTimeFilters
            hasBigScreenDesign
            isTransparent
            options={capitalStructureChartFilter}
            activeFilter={activeFilter}
            setTimeFilter={setTimeFilter}
          />
        </div>
      </div>
      <div className={Styles['chart-box-body']}>
        <CapitalCharts
          activeFilter={activeFilter}
          chartType={chartType}
          companyNumber={companyNumber}
          firstChartData={firstChartData}
        />
      </div>
    </div>
  );
};

export default ChartBox;
